import React from 'react';
import { BoardStats, contractSuits, suitsFullString } from '../../_models/models';
import { suitArray } from '../../../game-engine-interface/game-engine-helper';
import './board-stat-row.scss';

export interface RenderRowOptions {
    isMe: boolean;
    isSelected: boolean;
    isSingleRow?: boolean;
    disableClick?: boolean;
    onClick?: (index: number, stat: BoardStats) => void;
    dLabels: string[]; // N/E/S/W labels
}

/**
 * A reusable row renderer for traveller and stats tables.
 */
export function renderStatRowExternal(stat: BoardStats, index: number, opts: RenderRowOptions) {
    const { isMe, isSelected, isSingleRow, disableClick, onClick, dLabels } = opts;

    const clickHandler = disableClick || !onClick ? undefined : () => onClick(index, stat);

    return (
        <div
            key={`board-stat-row-${index}`}
            className={['board-stat-row', isMe ? 'isMe' : '', isSelected ? 'isSelected' : ''].filter(Boolean).join(' ')}
            onClick={clickHandler}
        >
            {/* Declarer */}
            <div className="declarer">{stat.key.d >= 0 ? dLabels[stat.key.d] : '-'}</div>

            {/* Contract */}
            <div className="contract">
                <div className={stat.key.c >= 10 ? contractSuits[`${stat.key.c}`.substring(1, 2)] : 'passOut'}>
                    {`${stat.key.c}`.substring(1, 2) === '4' && (
                        <div className="notrump">{contractSuits[`${stat.key.c}`.substring(1, 2)]}</div>
                    )}

                    <div className="level">{stat.key.c > 0 ? `${stat.key.c}`.substring(0, 1) : 'Pass out'}</div>

                    <div className="x">&nbsp;{' XX'.substring(0, stat.key.x)}</div>
                </div>
            </div>

            {/* Lead */}
            <div className="lead">
                <div
                    className={
                        stat.key.l >= 0 ? suitsFullString[suitArray[stat.key.l].substring(0, 1) as keyof typeof suitsFullString] : ''
                    }
                >
                    <span>{stat.key.l >= 0 ? suitArray[stat.key.l].substring(1) : '-'}</span>
                </div>
            </div>

            {/* Tricks */}
            <div className="tricks">{stat.key.c === 0 ? '-' : stat.key.r === 0 ? '=' : stat.key.r > 0 ? `+${stat.key.r}` : stat.key.r}</div>

            {/* Score */}
            <div className="score">{stat.key.s}</div>

            {/* Result (MP%) */}
            <div className="result">
                {Math.round((stat.result + Number.EPSILON) * 100) / 100}
                {isSingleRow && '%'}
            </div>

            {/* Player Count */}
            {isSingleRow ? (
                <div></div>
            ) : disableClick ? (
                <div className="players">({stat.count})</div>
            ) : (
                <div className="players">{stat.count}</div>
            )}
        </div>
    );
}
